<template lang="pug">
div
  //- add draggable property in order for the booking card to be draggable again
  .booking-card(
    :key="bookingProduct.Key"
    :style="`height: ${bookingCardHeight}px; top: ${bookingCardPosition}px;`"
    @click.stop="fetchBookingProduct(bookingProduct)"
    )
    BookingProductCardContent(
      :bookingProduct="bookingProduct"
      :bookingProductTime="bookingProductStartEndTime"
      :bookingCardPosition="bookingCardPosition"
      :bookingCardHeight="bookingCardHeight"
      )
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { bookingProductStartEndTime } from '@/vue/planboard/planboard-calendar/planboardCalendarUtil.js'
import BookingProductCardContent from '@/vue/planboard/planboard-calendar/BookingProductCardContent.vue'

export default {
  name: 'BookingProductCard',
  components: {
    BookingProductCardContent,
  },
  props: {
    bookingProductIndex: Number,
    bookingProduct: Object,
  },
  computed: {
    ...mapGetters('planboardModule', ['dragInProgress', 'planboardData']),
    bookingCardPosition() {
      const openingDateTime = new Date(this.planboardData.OpeningDateTime)
      const timeslotStartTime = new Date(this.bookingProduct.StartTime)
      const diff = Math.abs(openingDateTime.getTime() - timeslotStartTime.getTime()) / 3600000 // diff in hours
      return diff * 240 + 60 // multiple by the height for 1 hour
    },
    bookingCardHeight() {
      const bpStartTime = new Date(this.bookingProduct.StartTime)
      const bpEndTime = new Date(this.bookingProduct.EndTime)
      const diff = Math.abs(bpStartTime.getTime() - bpEndTime.getTime()) / 60000 // diff in minutes
      return (diff / 15) * 60 - 7
    },
    bookingProductStartEndTime() {
      return bookingProductStartEndTime(
        this.bookingProduct.StartTime,
        this.bookingProduct.EndTime,
        this.$locale,
        this.$timezone,
      )
    },
  },
  methods: {
    ...mapActions('planboardModule', ['setDragInProgress', 'fetchBookingProduct']),
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.booking-card
  background-color white
  border-radius 3px
  border-color grey300
  width 212px
  //- disable drag&drop for first version
  // cursor grab
  cursor pointer
  margin-left 4px
  position absolute
  border-width 1px
  border-style solid
  margin-top 4px
</style>
